import Vue from "vue";
import Vuex from "vuex";
import chat from "./modules/chat/chat"
import customerMappings from "./modules/import/customer_mappings/customer-mappings";
import logviewer from "./modules/logviewer/logviewer";
import twoFactorAuth from "./modules/two-factor-auth/two-factor-auth";
import news_hub from "./modules/news_hub/news_hub";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        chat,
        customerMappings,
        logviewer,
        twoFactorAuth,
        news_hub
    }
})
